
import fetchAboutPage from "./aboutapi";

// export const useAboutHero = () => {
//   return useQuery({
//     queryKey: ["homePage"],
//     queryFn: getAboutHero,
//     staleTime: Infinity,
//     gcTime: Infinity,   // ⚠️ React Query v5 uses gcTime instead of cacheTime
//     retry: 2,
//   });
// };
  // About page five content
export const getAboutsHero = () =>
  fetchAboutPage("34e71f42-7b59-4d69-b1a6-18c9475ff332");

export const getAboutSection = () =>
  fetchAboutPage("83edcdd7-8787-4940-8687-140cce0d4015");

export const getAboutStart = () =>
 fetchAboutPage("d40f406c-8e38-4987-9201-f8462eb72b9b");

export const getAboutFeature = () =>
  fetchAboutPage("48bf2477-e52c-4c7e-b936-bc18ff9946c1");

export const getAboutWhy = () =>
  fetchAboutPage("f9595f61-9a72-4ffb-a81e-c2f976deb9e3");

// about solution, Groone app footer api
export const getFooterASG = () =>
  fetchAboutPage("6a016175-7d0d-4665-b6bd-4f1795d771a9");
